import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import amarok from "../../../../assets/info/amarok-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const VWAmarok = () => {
  useSmallNav("Volkswagen Amarok");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Volkswagen Amarok"} bolder />
        <InfoHero image={amarok} />
        <InfoGrid>
          <div>
            <InfoHeader text={"VW Amarok Lift Kit from Pedders' Suspension"} />
            <p>
              Here at Pedders, we've been into off-roading Volkswagens for years
              and when the Amarok first hit the scene, we were very keen to see
              just how capable they are off-road.
            </p>
            <p>
              Combine the winning formula of the Volkswagen Amarok and Pedders'
              history and experience and you have a formidable combination!
            </p>
            <p>
              We're proud to bring one of the first lift kits to the market for
              the Amarok. We don't do things by halves here and the lift kit for
              the Amarok is a great example of this.
            </p>
            <p>
              Rather than just offering springs and lifting blocks, Pedders'
              lift kit is a complete kit of two Pedders' Heavy Duty Front Coil
              Springs, two Pedders' Gas Sports Ryder Struts, two Pedders' Heavy
              Duty Rear Leaf Springs and two Pedders Gas Sports Ryder Rear Shock
              Absorbers, all designed to work together giving you a great ride
              while improving in all areas.
            </p>
            <p>
              As all Pedders' products come with a two year warranty, so along
              with Volkswagens' reliability, you'll be sure to get through even
              the more hardcore off-roading and take the every day work as a
              walk in the park.
            </p>
            <InfoHeader
              size="smaller"
              text={"Introducing TrakRyder Expedition Kits"}
            />
            <p>
              The spring and shock absorber rates were developed to provide an
              improved load carrying capacity, with the advantage of increasing
              the stability in the way of less body roll, while at all times
              having consideration for the ride comfort. This kit is primarily
              designed to reinstate the ride height to as new with a minor
              enhance of up to 1" (25mm). The Expedition Kit will also improve
              the braking and steering of the vehicle when towing, provided you
              have a weight distribution tow pack fitted.
            </p>
            <InfoHeader size="smaller" text={"Will this fit my Amarok?"} />
            <p>
              For vehicles used as the primary towing and/or load carrying.
              Ideal for carrying heavy loads, towing horse floats or caravans
              and have the odd weekend of fun in the bush. This kit would be
              suitable for vehicles fitted with a nudge bar with driving lights,
              standard wheels and tyres and general equipment such as a fridge
              or tool box, but not excluding vehicles with extras such as: roof
              racks, long range fuel tanks, a rear drawer storage system and
              tool boxes.
            </p>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Volkswagen")
              .models.find((e) => e.display === "Amarok")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/9NU3nn4tX1c"
              title={"Amarok Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Amarok Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Amarok Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Volkswagen" model="Amarok" /> */}
      </Container>
    </section>
  );
};

export default VWAmarok;
